/**
 * Created by Rodrigo Quesada on 09/03/17.
 */
import {Component, Input} from '@angular/core';
import {BehaviorSubject, Observable, ReplaySubject} from 'rxjs';
import {FileLocation} from '../service/file-location.class';
import {PageStateService} from '../../../pages/shared/services/page-state.service';
import {Http, Request} from '@angular/http';
import {StormpathHttp} from 'angular-stormpath';
import {STORMPATH_CONFIG} from '../../../infrastructure/security/stormpath/stormpath.config';
import assign = require('core-js/fn/object/assign');

// region Other Classes
export class FileUploaderComponentModel {
    readonly filesLocation: FileLocation;

    private _uploadedSubject = new ReplaySubject<boolean>(1);
    readonly uploaded$: Observable<boolean> = this._uploadedSubject;

    constructor(data: Pick<FileUploaderComponentModel, 'filesLocation'>) {
        assign(this, data);
    }

    triggerUploadedEvent(): void { this._uploadedSubject.next(true); }
}
// endregion

@Component({
    selector: 'my-file-uploader',
    template: require('./file-uploader.component.html'),
    styles: [require('./file-uploader.component.scss')]
})
export class FileUploaderComponent {

    // region Input
    model$ = new BehaviorSubject<FileUploaderComponentModel | undefined>(undefined);

    @Input() get model(): FileUploaderComponentModel | undefined {
        return this.model$.getValue();
    }

    set model(value: FileUploaderComponentModel | undefined) {
        this.model$.next(value);
    }

    // endregion

    filesLocationUrl$: Observable<string>;

    private _unsavedDataId?: number;

    private readonly _stormpathHttp: StormpathHttp;

    constructor(private readonly _pageStateService: PageStateService, stormpathHttp: Http) {
        this._stormpathHttp = stormpathHttp as StormpathHttp;
        this.filesLocationUrl$ = this.model$.map(m => m ? m.filesLocation.url() : '');
    }

    onSelect() { this._unsavedDataId = this._pageStateService.addUnsavedDataState(); }

    onBeforeSend(event) {
        this._addHeaders(event.xhr);
    }

    private _addHeaders(xhr: XMLHttpRequest) {
        //workaround to add Authorization header to request
        const dummyRequest = new Request({url: `${STORMPATH_CONFIG.endpointPrefix}/api/dummy`});
        (this._stormpathHttp as any).addHeaders(dummyRequest);
        dummyRequest.headers.forEach((values, name) => xhr.setRequestHeader(name, values.join(',')));
    }

    onUpload() {
        this.model!.triggerUploadedEvent();
        this._removeUnsavedDataState();
    }

    onError() { this._removeUnsavedDataState(); }

    onClear() { this._removeUnsavedDataState(); }

    private _removeUnsavedDataState() {
        if (this._unsavedDataId !== undefined) this._pageStateService.removeUnsavedDataState(this._unsavedDataId);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/files/file-uploader/file-uploader.component.ts